var exports = {
  "mc": "Container__vYq-DP",
  "cs": "MetadataColumn__K2HOhs",
  "JU": "Label__WOP9cm",
  "WT": "Value__rm67ZV",
  "Gr": "ExternalLink__g6k7bS",
};

module.exports = exports;
